import { render, staticRenderFns } from "./Classifiers.vue?vue&type=template&id=6f50e596"
import script from "./Classifiers.vue?vue&type=script&lang=js"
export * from "./Classifiers.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports